/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnDestroy, OnInit, ViewChild, } from '@angular/core';
import { UserService, AccountService,LogService } from '../../../../services';
import { Notification, NotificationGroup, User, Helpers } from '../../../../model';
import { UserProvider } from '../../../../providers';
import { CrmAlertComponent } from 'src/app/components/fields';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { ChangePasswordModal } from 'src/app/components/modal';

@Component({
  selector: 'page-notification',
  templateUrl: 'notification.page.html',
  styleUrls: ['notification.page.scss']
})

export class NotificationPage implements OnInit, OnDestroy {
  @ViewChild('alert') alert: CrmAlertComponent;
  notifications: Notification[] = [];
  tempNotifications: Notification[];
  user: User;
  private userSub: any;
  isLoading = false;
  changeModal: BsModalRef;
  saveSub: any;
  changeSub: any;
  NotificationGroup = NotificationGroup;
  isReportNoficationChecked: boolean;
  isReportWatchNoficationChecked: boolean;

  constructor(
    private userService: UserService,
    private userProvider: UserProvider,
    private modalService: BsModalService,
    private accountService: AccountService,
    private logService : LogService
  ) {

    this.saveSub = this.accountService.onSaveNotification.subscribe(() => {this.onSave();});
    this.changeSub = this.accountService.onChangePassword.subscribe(() => {this.onChange();});
  }

  ngOnInit(): void {
    this.userSub = this.userService.user$.subscribe(u => this.user = u);
    this.getUserNotifications();
  }

  ngOnDestroy(): void {
    if (this.userSub) this.userSub.unsubscribe();
    if (this.saveSub) this.saveSub.unsubscribe();
    if (this.changeSub) this.changeSub.unsubscribe();
  }

  private getUserNotifications(): void {
    this.userProvider.getNotifications()
      .subscribe(data => {
        if (data.success) {
          this.notifications = Notification.parseArray(data.result);
          this.updateTempNotifications();
          if (this.notifications) {
            this.isAllReportNoficationChecked();
            this.isAllReportWatchingNoficationChecked();
          }
        } else this.logService.error(data);
      }, error => {
        this.logService.error(error);
      });
  }

  isModified(): boolean {
    return false;

    /* FIXME: needs Redo
    let dataModified:boolean = false;
    this.tempNotifications.map(original => {
      if(!dataModified){
        this.notifications.map(modified => {
          if(original.GROUP === modified.GROUP &&
            modified.SELECTED != original.SELECTED &&
            original.NAME === original.NAME)

            dataModified = true;
        });
      }
    });
    return dataModified;*/
  }

  updateTempNotifications():void{
    this.tempNotifications = JSON.parse(JSON.stringify(this.notifications));
  }

  showSaveAlert(): void {
    this.alert.showError('Please save modified changes.');
  }

  notificationToggle(n: Notification): void {
    this.alert.hide();

    if (n.SELECTED) {
      this.userProvider.addMyNotification(n.ID)
        .subscribe(data => {
          if (data.success) {
            this.user.NOTIFICATIONS.push(Notification.parse(data.result));
            this.updateTempNotifications();
            this.alert.showSuccess('User Report Notifications Settings was successfully saved.');
          } else{
            this.alert.showError(data.error.txt);
            this.logService.log(JSON.stringify(data, null, 2));
          }
        });
    } else {
      this.userProvider.removeMyNotification(n.ID)
        .subscribe(data => {
          if (data.success) {
            const n = Notification.parse(data.result);

            /*for (let i = 0; i < this.user.NOTIFICATIONS.length; i++)
              if (this.user.NOTIFICATIONS[i].ID === n.ID)
                this.user.NOTIFICATIONS.splice(i, 1);*/

            this.updateTempNotifications();
            this.alert.showSuccess('User Report Notifications Settings was successfully saved.');
          } else {
            this.alert.showError(data.error.txt);
            this.logService.log(JSON.stringify(data, null, 2));
          }
        });
    }

    this.isAllReportNoficationChecked();
    this.isAllReportWatchingNoficationChecked();

    setTimeout(() => {
      this.alert.hide();
    }, 5000);
  }

  onSave(): void {
    this.alert.hide();
    if (this.isReportNoficationChecked || this.isReportWatchNoficationChecked) {
      this.userProvider.addMultipleNotificationsToMe(this.notifications).subscribe(data => {
        if (data.success) {
          this.updateTempNotifications();
          this.alert.showSuccess('User Report Notifications Settings was successfully saved.');
        }else{
          this.alert.showError(data.error.txt);
        }
      });

    } else {
      this.userProvider.removeMultipleNotificationsToMe(this.notifications).subscribe(data => {
        if (data.success) {
          this.updateTempNotifications();
          this.alert.showSuccess('User Report Notifications Settings was successfully saved.');
        }else{
          this.alert.showError(data.error.txt);
        }
      });
    }

    setTimeout(() => {
      this.alert.hide();
    }, 5000);
  }

  onChange(): void {
    this.alert.hide();
    this.changeModal = this.modalService.show(ChangePasswordModal, Helpers.getModalConfig());
    const ackSubject = new Subject<boolean>();
    this.changeModal.content.subject = ackSubject;
    this.changeModal.content.user = this.user;

    ackSubject.subscribe(value => {
      if (value) {
        this.alert.showSuccess('You successfully changed your passwod.');

        setTimeout(() => {
          this.alert.hide();
        }, 3000);
      }
    });
  }

  onReportNotificationCheckChanged(value: any): void {
    let param:string = '';
    this.notifications.filter(ns => ns.GROUP === NotificationGroup.REPORT).map(n => {
      if (n.ID !== 'REPORT_IMPORTED') {
        if (n.SELECTED !== value) {
          n.SELECTED = value;
          param += n.ID + ',';
        }
      }
      return n;
    });

    // Remove ',' from last
    param = param.substr(0, param.length - 1);

    // Call API
    if(value){
      this.userProvider.addMyNotification(param).subscribe(data => {
        if (data.success) {
          // Update temp variable
          this.updateTempNotifications();
          this.alert.showSuccess('User Report Notifications Settings was successfully saved.');
        }else{
          this.alert.showError(data.error.txt);
        }
      });
    }else{
      this.userProvider.removeMyNotification(param).subscribe(data => {
        if (data.success) {

          // Update temp variable
          this.updateTempNotifications();
          this.alert.showSuccess('User Report Notifications Settings was successfully saved.');
        }else{
          this.alert.showError(data.error.txt);
        }
      });
    }

    setTimeout(() => {
      this.alert.hide();
    }, 5000);
  }

  onReportWatchNotificationCheckChanged(value: any): void {
    let param:string = '';
    this.notifications.filter(ns => ns.GROUP === NotificationGroup.WATCH).map(n => {
      if (n.SELECTED !== value) {
        n.SELECTED = value;
        param += n.ID + ',';
      }
      return n;
    });

    // Remove ',' from last
    param = param.substr(0, param.length - 1);

    // Call API
    if(value){
      this.userProvider.addMyNotification(param).subscribe(data => {
        if (data.success) {
          // Update temp variable
          this.updateTempNotifications();
          this.alert.showSuccess('User Report Notifications Settings was successfully saved.');
        }else{
          this.alert.showError(data.error.txt);
        }
      });
    }else{
      this.userProvider.removeMyNotification(param).subscribe(data => {
        if (data.success) {

          // Update temp variable
          this.updateTempNotifications();
          this.alert.showSuccess('User Report Notifications Settings was successfully saved.');
        }else{
          this.alert.showError(data.error.txt);
        }
      });
    }

    setTimeout(() => {
      this.alert.hide();
    }, 5000);
  }

  isAllReportNoficationChecked(): void {
    let isCheckAll = true;
    for (const n of this.notifications.filter(ns => ns.GROUP === NotificationGroup.REPORT)) {
      if (n.ID !== 'REPORT_IMPORTED') {
        if (!n.SELECTED) {
          isCheckAll = false;
          break;
        }
      }
    }

    this.isReportNoficationChecked = isCheckAll;
  }

  isAllReportWatchingNoficationChecked(): void {
    let isCheckAll = true;
    for (const notif of this.notifications.filter(ns => ns.GROUP === NotificationGroup.WATCH)) {
      if (!notif.SELECTED) {
        isCheckAll = false;
        break;
      }
    }

    this.isReportWatchNoficationChecked = isCheckAll;
  }

}
